import type { UserStatus } from '@/shared/utils/format-status.js';

export function resolveUserStatusChipColors(status: UserStatus): { bgcolor: string; color: string } {
    return status === 'ATIVO' ? { bgcolor: '#D1FAE5', color: '#166534' } : { bgcolor: '#FEE2E2', color: '#991B1B' };
}
